import { CEntity } from '@ts/ui-models';

const deepCopy = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => deepCopy(item));
  }

  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = deepCopy(obj[key]);
    return acc;
  }, {} as any);
};

const deepCopyMiddleware = storeAPI => next => action => {
  if (
    action.payload?.value &&
    typeof action.payload?.value === 'object' &&
    action.payload?.value instanceof CEntity &&
    !Array.isArray(action.payload?.value)
  ) {
    action.payload.value = deepCopy(action.payload.value);
  }
  return next(action);
};

export default deepCopyMiddleware;
